const initStickyEstimate = () => {
    const stickyEstimate = document.querySelector('.sticky-estimate');
    if (!stickyEstimate) return;
    const toggleButton = stickyEstimate.querySelector('.sticky-estimate__toggle');
    if (!toggleButton) return;

    const scrollThreshold = 600;
    const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        const translateY = Math.max(0, 100 - (scrollY / scrollThreshold * 100));
        const unit = stickyEstimate.classList.contains('hidden') ? 'px' : '%';
        stickyEstimate.style.transform = `translateY(${translateY}${unit})`;
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    toggleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        stickyEstimate.classList.toggle('hidden');
        toggleButton.classList.toggle('visible');
        if (stickyEstimate.classList.contains('hidden')) {
            stickyEstimate.style.transform = '';
        } else {
            handleScroll();
        }
    });

    stickyEstimate.addEventListener('click', () => {
        if (stickyEstimate.classList.contains('hidden')) {
            stickyEstimate.classList.remove('hidden');
            toggleButton.classList.remove('visible');
            handleScroll();
        }
    });
}

export { initStickyEstimate };